import axios from './axiosInstances/axiosInstance';

export const setBasketDispatchAddress = (basketGuid, address) => {
  return axios.put(`baskets/${basketGuid}/dispatchaddress`, address);
};
